export default __webpack_public_path__ + "assets/front/scss/user-authentication.3115a40e17707d90999299e720c44ac0.css";